import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Common.css';

function Transactions({ apiBase }) {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [phone, setPhone] = useState('');
  const [pagination, setPagination] = useState(null);

  useEffect(() => {
    loadTransactions();
  }, []);

  const loadTransactions = async (page = 1) => {
    try {
      setLoading(true);
      let url = `${apiBase}/api/admin/transactions?page=${page}&limit=20`;
      if (status) url += `&status=${status}`;
      if (phone) url += `&phone=${phone}`;

      const response = await axios.get(url);
      if (response.data.success) {
        setTransactions(response.data.data);
        setPagination(response.data.pagination);
      }
    } catch (error) {
      console.error('Error loading transactions:', error);
    } finally {
      setLoading(false);
    }
  };

  const getBadgeClass = (paid) => {
    return paid ? 'badge badge-success' : 'badge badge-warning';
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('en-KE', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="component-container">
      <div className="filter-bar">
        <select 
          value={status} 
          onChange={(e) => setStatus(e.target.value)}
          className="filter-select"
        >
          <option value="">All Status</option>
          <option value="paid">Paid</option>
          <option value="pending">Pending</option>
        </select>

        <input 
          type="text" 
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Search by phone (254...)"
          className="filter-input"
        />

        <button onClick={() => loadTransactions()} className="btn btn-primary">
          Apply Filters
        </button>
      </div>

      {loading ? (
        <div className="loading">Loading transactions...</div>
      ) : (
        <>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Phone</th>
                  <th>Amount</th>
                  <th>Package</th>
                  <th>Status</th>
                  <th>Receipt</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                {transactions.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="empty-state">No transactions found</td>
                  </tr>
                ) : (
                  transactions.map((transaction) => (
                    <tr key={transaction.id}>
                      <td>#{transaction.id}</td>
                      <td>{transaction.phone}</td>
                      <td>KES {parseFloat(transaction.amount).toFixed(2)}</td>
                      <td>{transaction.package_name || 'Custom'}</td>
                      <td>
                        <span className={getBadgeClass(transaction.paid)}>
                          {transaction.paid ? 'Paid' : 'Pending'}
                        </span>
                      </td>
                      <td>{transaction.mpesa_receipt_number || '-'}</td>
                      <td>{formatDate(transaction.created_at)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {pagination && pagination.pages > 1 && (
            <div className="pagination">
              <button 
                onClick={() => loadTransactions(pagination.page - 1)}
                disabled={pagination.page === 1}
                className="btn"
              >
                Previous
              </button>
              <span>Page {pagination.page} of {pagination.pages}</span>
              <button 
                onClick={() => loadTransactions(pagination.page + 1)}
                disabled={pagination.page === pagination.pages}
                className="btn"
              >
                Next
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default Transactions;
